<template>
    <section class="auth-page">

        <!-- This div is used for style purpose -->
        <div></div>

        <form @submit.prevent="submitForm" type="POST" class="auth-page--form">
            <img class="auth-page--logo" src="@/assets/logo_dark.png" alt="XMLShopconnector" />
        </form>

        <!-- <router-link :to="{ name: 'Login' }">{{ t('auth.back_to_login') }}</router-link> -->
    </section>
</template>
<script>
import swal from 'sweetalert';

import { put } from '@/helpers/http';
import handleError from '@/helpers/error';

export default {
    name: 'RegisterConfirm',

    mounted() {
        this.activateAccount();
    },

    methods: {
        activateAccount() {
            put({
                url: `${this.$API_URL}/api/register/confirm/${this.$route.params.token}`,
            })
                .then(() => {
                    swal(this.$translate.text('alert.success.message.registered'))
                        .then(() => {
                            this.$router.push('/login');
                        });
                })
                .catch((error) => {
                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });
                });
        },
    },
};
</script>
<style lang="scss" scoped>
.auth-page {
    width: 100%;
    min-height: 100vh;
    background-color: $bluegrey;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;

    &--logo {
        width: 100%;
        height: auto;
        max-width: 400px;
        margin-bottom: 48px;
    }

    &--form {
        padding: 20px;
        display: flex;
        flex-direction: column;
        width: 400px;

        input {
            margin-bottom: 8px;
            border: 0;
            border-radius: 4px;
            height: 40px;
            text-align: center;
            font-size: 16px;
        }

        button {
            margin-top: 16px;
        }

        h3, p {
            text-align: center;
        }

        h3 {
            font-size: 32px;
            margin-bottom: 16px;
        }

        p {
            margin-bottom: 16px;
        }
    }

    a {
        margin-bottom: 24px;
        color: $blue;
        text-decoration: none;

        &:hover {
            color: darken($blue, 10%);
        }
    }
}
</style>
